import { mat4Determinant3 } from '../math/mat4-determinant3.js';
import { buildPrimitiveState } from '../material/pbr/pbr-primitive-topology.js';

const MSH_REVERSE_WINDING = 1 << 11;
const MSH_TOPOLOGY_SHIFT = 12;
const MSH_INDEX_U32 = 1 << 15;
const feature = {
  id: "_primitive",
  async applyMesh(meshData, mesh) {
    const mode = meshData._primitive?.mode;
    const topo = mode === 0 ? 1 : mode & 1 ? mode + 3 >> 1 : void 0;
    const mirrored = mat4Determinant3(meshData._worldMatrix) > 0;
    let features = topo ? topo << MSH_TOPOLOGY_SHIFT | (topo > 2 && mesh._gpu.indexFormat === "uint32" ? MSH_INDEX_U32 : 0) : 0;
    if (mirrored) {
      features |= MSH_REVERSE_WINDING;
    }
    if (topo || mirrored) {
      const prim = topo ? buildPrimitiveState(topo, mesh._gpu.indexFormat === "uint32") : {};
      if (mirrored) {
        prim.frontFace = "cw";
      }
      mesh._primitive = prim;
    }
    if (features) {
      mesh._primitiveFeatures = features;
    }
  }
};

export { feature as default };
//# sourceMappingURL=gltf-feature-primitive.js.map
